module.exports = __webpack_public_path__ + "img/p3-p1-molihua.5d2235c0.png";